import { RouteNames } from '$app/router'
import { authMethods, AuthMethods } from './auth'

export const VITE_DEPLOYMENT_TAG = import.meta.env.VITE_DEPLOYMENT_TAG

export const NAMESPACE = 'genie-auth-webview'

export const LOCAL_STORAGE_KEY_SEPARATOR = ':'

export const APP_TITLE = `${import.meta.env.VITE_APP_TITLE}`

export const THEME_NAME = import.meta.env.VITE_THEME_NAME

export const DEFAULT_ROUTE: RouteNames = 'profileDetail'

export const DEFAULT_AUTH_METHOD: AuthMethods = authMethods[0]

export const GENERAL_TIME_FORMAT_WITH_TIMEZONE = 'dd MMM yyyy, hh:mma z'

export const DEFAULT_OTP_CODE_LENGTH = 6

export const DEFAULT_OTP_RETRY_TIMER = 1000 * 60

export const CARRO_ID_APP_QR_SCANNER_ROUTE = `${import.meta.env.VITE_CARRO_ID_APP_QR_SCANNER_ROUTE}`

export const GENDER_OPTIONS = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
  { label: 'Other', value: 'other' }
]

export const APP_LINKS = {
  apk: import.meta.env.VITE_APK_DOWNLOAD_URL,
  appstore: import.meta.env.VITE_APPSTORE_DOWNLOAD_URL,
  playstore: import.meta.env.VITE_PLAYSTORE_DOWNLOAD_URL
}
